import { createContext, useContext } from 'react';

export interface ErrorBoundaryContextData {
  crumbs: string[];
}

export const defaultContextValue = {
  crumbs: [],
};

const ErrorBoundaryContext = createContext<ErrorBoundaryContextData>({
  ...defaultContextValue,
});

export const useErrorBoundaryContext = () => useContext(ErrorBoundaryContext);

export default ErrorBoundaryContext;
